<div class="d-block">
    <span class="headline-6">
        Donor Search
    </span>
    <div class="mt-3">
        <div class="card__right-side d-flex search">
            <div class="search__icon-wrapper">
                <i class="fas fa-search input-prefix"></i>
            </div>
            <input [formControl]="itemSearch" class="form-control--search" placeholder="Enter Name Or Email" />
            <div class="search__icon-wrapper--cross px-1">
                @if(itemSearch.value.length > 0){
                    <span class="cursor--pointer" (click)="resetSearch()">X</span>
                }
            </div>
        </div>
    </div>
</div>

<div class="container mt-3">
    <span class="body-1">
        Search Results
    </span>

    @for(item of searchedItems; track item.id) {
        <div class="d-flex champions-container mt-2">
            <div (click)="seeItemDetails(item)" class="d-flex w-100 align-items-center cursor--pointer p-2">
                <div class="col-8">
                    <span class="subtitle-1 cursor--pointer">{{item.name}}</span>
                    <br>
                    <span class="body-3 grey-text font-weight-400 cursor--pointer">{{item.email}}</span>
                </div>
                <div class="col-4 d-flex align-items-center justify-content-end grey-text">
                    <div class="d-flex flex-column">
                        <span class="body-3 font-weight-400 cursor--pointer">{{item.transactionCount}} Donation(s)</span>
                        @if (item.pledgePerEvent) {
                            <span class="body-3 font-weight-400 cursor--pointer">{{item.pledgeCount}} Pledge(s)</span>
                        }
                    </div>
                    <i class="fas fa-chevron-right ml-2"></i>
                </div>
            </div>
        </div>
    }
   
    @if(searchedItems.length < 1) {
        <div class="d-flex body-1 justify-content-center mt-3">
            No Matching Fundraisers and Donors...
        </div>
    }
</div>
